import { render, staticRenderFns } from "./HouseList.vue?vue&type=template&id=1935bcde&scoped=true&"
import script from "./HouseList.vue?vue&type=script&lang=js&"
export * from "./HouseList.vue?vue&type=script&lang=js&"
import style0 from "./HouseList.vue?vue&type=style&index=0&id=1935bcde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1935bcde",
  null
  
)

component.options.__file = "HouseList.vue"
export default component.exports